/**
 * Days in the year for daily interest, from a loan's servicing Daily Rate Basis
 * (`ServicingNotes.data.dailyRateBasis`: '360' | '365' | 'actual_360' | 'actual_365').
 *
 * The port of the server's `dailyRateDenominator` (`src/utils/non-dutch-pi.ts`), so a figure this
 * app previews is divided by the same denominator the server will divide the stored figure by.
 * Only the denominator is decided here - day counts are actual days everywhere that uses this.
 *
 * Note the defaults, which are the server's and are not the obvious ones: anything NAMING 365 is
 * 365, so 'actual_365' lands there without being listed; an absent, null or empty basis is ALSO
 * 365; and only a basis that names something else (360, actual_360) is 360. A loan whose basis was
 * never set therefore accrues over 365, not over the 360 a reader might assume.
 *
 * Not to be confused with `pages/Loan/PostClosing/dailyRateBasis`'s `getDailyRateYearDays`, which
 * resolves the same field the other way round - exact matches only, defaulting to 360 - for the
 * legacy Purchase Advice screens. Charges, payments, payoffs and statements all follow this one.
 */
export const dailyRateDenominator = (dailyRateBasis?: string | number | null): 360 | 365 =>
  String(dailyRateBasis || '365').includes('365') ? 365 : 360
